import {Component, Input, OnInit, NgModule, ViewEncapsulation, Injector} from '@angular/core';
import {QueryValue} from "../../../../../services/model/queryValue";
import {FilterValue} from "../../../../../services/model/filterValue";
import {EfastFilterBaseComponent} from "../efast-filter-base.component";
import {Bucket} from "../../../../../services/model/bucket";


@Component({
    selector: 'efast-filter-assets',
    templateUrl: 'efast-filter-assets.component.html',
    styleUrls: ['efast-filter-assets.component.css'],
    standalone: false
})

export class EfastFilterAssetsComponent extends EfastFilterBaseComponent implements OnInit {

    rangeToLbl: string;
    rangeTitle: string;
    applyBtn: string;
    errorMsg: string;
    applyFromValue: string = "";
    applyToValue: string = "";
    errorFound1: boolean ;
    errorFound2: boolean ;
    fieldFromId: string;
    fieldToId: string;
    rangeTitleId: string;
    curQueryValue: QueryValue = new QueryValue();


    constructor(protected injector: Injector) {
        super(injector);
    }

    ngOnInit() {

        this.title= this.cacheService.getLabelFromResource('FILTER:FILTERAssetsTitle');

        let filterValues: FilterValue[] = new Array();

        this.filterCategory.filterType = this.staticsService.getFilterType().ASSETS;

        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERAssetsLbl1'),
            this.staticsService.getAssetsFilter().ASSETS_LESS));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERAssetsLbl2'),
            this.staticsService.getAssetsFilter().ASSETS_TO_500000));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERAssetsLbl3'),
            this.staticsService.getAssetsFilter().ASSETS_TO_1000000));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERAssetsLbl4'),
            this.staticsService.getAssetsFilter().ASSETS_TO_10000000));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERAssetsLbl5'),
            this.staticsService.getAssetsFilter().ASSETS_TO_More));

        this.rangeToLbl = this.cacheService.getLabelFromResource('FILTER:FILTERAssetsTo');
        this.rangeTitle = this.cacheService.getLabelFromResource('FILTER:FILTERAssetsRangeTitle');
        this.applyBtn = this.cacheService.getLabelFromResource('FILTER:FILTERAssetsApplyBtn');
        this.errorMsg = this.cacheService.getLabelFromResource('messages:msg.invalidRange');

        this.filterCategory.filterValues = filterValues;
        this.fieldFromId = "applyFromValueId";
        this.fieldToId = "applyToValueId";

        this.rangeTitleId = "assetRangeId";

        super.ngOnInit();
    }

    apply() {
        this.errorFound1 = false;
        this.errorFound2 = false;
        this.applyFromValue = this.cleanField(this.applyFromValue);
        this.applyToValue = this.cleanField(this.applyToValue);
        if ((this.applyFromValue.trim().length != 0) || (this.applyToValue.trim().length != 0)) {
            if (this.applyFromValue.trim() != "*") {
                if (isNaN(Number(this.applyFromValue.trim()))) {
                    this.errorFound1 = true;
                } else {
                    if (this.applyToValue.trim().length == 0) {
                        this.applyToValue = "*";
                    }
                    if (this.applyFromValue.trim().length == 0) {
                        this.applyFromValue = "0";
                    }

                }
            }
            if (!this.errorFound1) {
                if (this.applyToValue.trim() != "*") {
                    if (isNaN(Number(this.applyToValue.trim()))) {
                        this.errorFound2 = true;
                    } else {
                        if (this.applyFromValue.trim().length == 0) {
                            this.applyFromValue = "0";
                        }
                        if (this.applyToValue.trim().length == 0) {
                            this.applyToValue = "*";
                        }
                    }
                }
            }

            if ((!this.errorFound1) && (!this.errorFound2)) {
                this.errorFound1 = false;
                this.errorFound2 = false;
                let queryValue: QueryValue = new QueryValue();
                queryValue.value = this.generateDynamicQueryValue();
                queryValue.displayValue = this.generateDynamicQueryDisplayValue();

                this.curQueryValue = this.queryManagerService.updateOrAdd(this.curQueryValue, queryValue,
                    this.staticsService.getCategoryType().ASSETS, true);
            }
        }
    }

    getFieldId(): string {
        if (this.errorFound1) {
            return this.fieldFromId;
        }
        else {
            return this.fieldToId;
        }

    }

    private generateDynamicQueryValue() : string {
        return "[" + this.applyFromValue.trim() +  " TO " + this.applyToValue.trim() + "]";
    }

    private generateDynamicQueryDisplayValue() : string {
        return this.applyFromValue.trim() +  " TO " + this.applyToValue.trim();
    }

    protected expandClick() {
        super.expandClick();
    }
    //extended
    protected searchChangeEvent() {

        this.setBucket(this.applicationService.getAfsForm().facets.assetseoy.buckets);
        if (this.bucket != null) {
            let facets: Bucket[] = this.bucket;
            let idx: number  = 0;
            for (let facet of facets) {
                if (this.filterCategory.filterType == this.staticsService.getFilterType().ASSETS) {
                    if (idx != -1) {
                        this.filterCategory.filterValues[idx].count = facet.count.toString();
                    }
                    idx++;
                }
            }
        }
        if (!this.queryManagerService.isQueryCategoryInManager(this.staticsService.getCategoryType().ASSETS)){
            //clean yourself
            this.applyFromValue = "";
            this.applyToValue= "";
            this.errorFound1 = false;
            this.errorFound2 = false;
        }

    }

    //extended
    protected rowClick(filterValue: FilterValue) {
        super.rowClick(filterValue,true);
        this.queryManagerService.addQueryValueNoSearch(this.staticsService.getCategoryType().ASSETS, this.queryValue, true)
    }

}
